import * as Yup from "yup";

import { Box, Button, TextField, Typography, styled } from "@mui/material";
import { useDispatch, useSelector } from "../../stores";
import { useEffect, useState } from "react";

import { Close } from "@mui/icons-material";
import { login } from "../../stores/auth/authSlice";
import { selectUser } from "../../stores/auth/authSelectors";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const user = useSelector(selectUser);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState("")

    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
    });

    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting, setStatus }) => {
            try {
                await dispatch(login(values));
                setErrorMessage("Invalid credentials")
               
            } catch (err: any) {
                setStatus({ error: err || "Login failed. Please try again." });
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (user.user) {
            navigate("/home");
        }
    }, [user, navigate]);

    return (
        <PageWrapper>
            <Box
                width="95%"
                display="flex"
                position="absolute"
                top={60}
                justifyContent="flex-end"
                onClick={() => navigate("/home")}
            >
                <Close />
            </Box>

            <FormContainer>
                <Typography variant="h4" gutterBottom>
                    Login
                </Typography>

                {errorMessage && (
                    <Typography color="error" sx={{ mt: 2 }}>
                        {errorMessage}
                    </Typography>
                )}

                <form onSubmit={formik.handleSubmit}>
                    <StyledTextField
                        fullWidth
                        label="Email"
                        variant="outlined"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.email && Boolean(formik.errors.email)
                        }
                        helperText={formik.touched.email && formik.errors.email}
                    />
                    <StyledTextField
                        fullWidth
                        label="Password"
                        type="password"
                        variant="outlined"
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                        }
                        helperText={
                            formik.touched.password && formik.errors.password
                        }
                    />
                    <StyledButton
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        Login
                    </StyledButton>
                </form>
                <Typography variant="body2">
                    Don't have an account?{" "}
                    <StyledLink onClick={() => navigate("/register")}>
                        Register
                    </StyledLink>
                </Typography>
            </FormContainer>
        </PageWrapper>
    );
};

export default Login;

// Styled Components
const PageWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundImage: "url(/assets/tawhadi_background.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
});

const FormContainer = styled(Box)({
    padding: "2rem",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

const StyledTextField = styled(TextField)({
    marginBottom: "1rem",
});

const StyledButton = styled(Button)({
    width: "100%",
    padding: "0.8rem",
    marginTop: "1rem",
});

const StyledLink = styled("span")({
    color: "blue",
    cursor: "pointer",
    textDecoration: "underline",
});
